<template>
  <section role="main">
    <form
      @submit.prevent="submit2"
      class="mt-5 mr-2 ml-2 justify-content-md-center"
    >
      <div class="col">
        <section class="card">
          <header class="card"></header>
          <div class="card-body">
            <div class="" v-if="!isLoading && showThankYou">
              <div class="row text-center f-weight-550">
                <div class="col-lg-12 text-center">
                  <h3 class="label f-weight-550">
                    Thank you! We look forward to seeing you.
                  </h3>
                  <h4 class="label f-weight-550">
                    {{ currentPatientAssociated.officeName }}
                  </h4>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-12">
                <content-placeholders :rounded="true" :centered="true">
                  <content-placeholders-text :lines="5" />
                </content-placeholders>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="row justify-content-end">
              <div class="col-sm-9">
                <button
                  type="reset"
                  class="btn btn-default mr-2"
                  @click="prev"
                  v-if="getTaskPreviousTaskType"
                >
                  Back
                </button>
                <btn-saving
                  :is-saving="isSaving"
                  :loading-text="'Completing...'"
                  :display-text="'Continue'"
                />
              </div>
            </div>
          </footer>
        </section>
      </div>
    </form>
  </section>
</template>

<script>
// import Multiselect from 'vue-multiselect'
import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import api from '../../api/http-common.js'
import { mapGetters, mapActions } from 'vuex'
import BtnSaving from '../button-saving.vue'
export default {
  components: {
    // Multiselect,
    BtnSaving
  },
  data() {
    return {
      isSaving: false,
      isLoading: false,
      showThankYou: false,
      form: {
        questions: [
          {
            code: 'SeenChiropractor',
            question: 'Have you ever seen a chiropractor before?',
            answer: ''
          },
          {
            code: 'DoctorToKnow',
            question: 'Is there anything else you want the doctor to know?',
            answer: ''
          }
        ],
        seenChiro: null,
        otherInquiry: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'getProfilePatientAssociated',
      'getTaskCurrentCaseHistoryId',
      'getTaskPreviousTaskType',
      'getTaskCurrentTaskType',
      'currentPatientAssociated',
      'getTaskInfo',
      'getTaskItem',
      'getTaskCode'
    ]),
    yesNoSelection() {
      return ['Yes', 'No']
    },
    TaskInfo() {
      if (!this.getTaskInfo || this.getTaskInfo === '') {
        return undefined
      }
      try {
        return JSON.parse(this.getTaskInfo)
      } catch (e) {
        console.warn('NphThankyou: invalid getTaskInfo JSON', e)
        return undefined
      }
    },
    TaskItem() {
      return this.getTaskItem
    }
  },
  methods: {
    ...mapActions([
      'setTaskCurrentTaskType',
      'clearUrlLinkInfo',
      'setTaskCode',
      'setTaskInfo',
      'setTaskItem',
      'setCurrentMsgInfo',
      'setMsgCurrentPage',
      'setBillingStatementTask'
    ]),
    async submit() {
      const facilityId = this.currentPatientAssociated.facilityID
      const patientId = this.currentPatientAssociated.patientID
      const caseHistoryId = this.getTaskCurrentCaseHistoryId

      // 1) Resolve task id: TaskInfo (TaskID/taskID), TaskItem.taskID, or fallback from gettasks
      let taskId =
        this.TaskInfo?.TaskID ??
        this.TaskInfo?.taskID ??
        this.TaskItem?.taskID

      if ((taskId === undefined || taskId === null) && facilityId && patientId) {
        try {
          const res = await api.patient.request.gettasks({
            facilityId,
            patientId
          })
          const raw = res.data
          const list = Array.isArray(raw) ? raw : (raw?.tasks && Array.isArray(raw.tasks) ? raw.tasks : [])
          const healthHistoryTypes = ['NPH', 'AANPH', 'AACH', 'CH']
          const match = list.find(
            (t) =>
              t.taskID > 0 &&
              (healthHistoryTypes.includes(t.taskType) ||
                t.taskType === this.getTaskCode)
          )
          if (match) {
            taskId = match.taskID
          }
        } catch (e) {
          console.warn('NphThankyou: fallback gettasks for taskId failed', e)
        }
      }

      // 2) Mark case history complete (NPH / health history flow)
      if (caseHistoryId) {
        try {
          await api.task.request.updateCaseHistoryComplete({
            facilityId,
            caseHistoryId
          })
        } catch (e) {
          console.error('NphThankyou: updateCaseHistoryComplete failed', e)
        }
      }

      // 3) Mark the task complete (must have valid task id; backend may expect number)
      const id = taskId !== undefined && taskId !== null ? Number(taskId) : undefined
      if (id !== undefined && !Number.isNaN(id)) {
        try {
          await api.task.request.updateTaskComplete({
            facilityId,
            id,
            patientId
          })
        } catch (e) {
          console.error('NphThankyou: updateTaskComplete failed', e)
        }
      } else {
        console.warn('NphThankyou: no task id available, updateTaskComplete skipped', {
          hasTaskInfo: !!this.TaskInfo,
          hasTaskItem: !!this.TaskItem,
          getTaskCode: this.getTaskCode
        })
      }

      // 4) Safety net: fetch tasks again and complete any remaining patient health history task
      //    so the form is marked complete even if taskId was missing or the first update failed
      await this.ensureHealthHistoryTaskCompleted()

      await this.clearUrlLinkInfo()
      this.isSaving = false
    },
    /**
     * Fetch tasks from the server and complete any patient health history task (NPH, AANPH, AACH, CH)
     * that is still incomplete. Ensures the health history form is marked complete after the last step.
     */
    async ensureHealthHistoryTaskCompleted() {
      const facilityId = this.currentPatientAssociated.facilityID
      const patientId = this.currentPatientAssociated.patientID
      if (!facilityId || !patientId) return

      try {
        const res = await api.patient.request.gettasks({ facilityId, patientId })
        const raw = res.data
        const list = Array.isArray(raw)
          ? raw
          : raw?.tasks && Array.isArray(raw.tasks)
            ? raw.tasks
            : []
        const healthHistoryTypes = ['NPH', 'AANPH', 'AACH', 'CH']
        const incompleteHealthHistoryTasks = list.filter(
          (t) =>
            t.taskID != null &&
            Number(t.taskID) > 0 &&
            healthHistoryTypes.includes(t.taskType)
        )

        for (const task of incompleteHealthHistoryTasks) {
          const taskId = Number(task.taskID)
          if (Number.isNaN(taskId)) continue
          try {
            await api.task.request.updateTaskComplete({
              facilityId,
              id: taskId,
              patientId
            })
          } catch (e) {
            console.warn('NphThankyou: ensureHealthHistoryTaskCompleted updateTaskComplete failed for task', taskId, e)
          }
        }
      } catch (e) {
        console.warn('NphThankyou: ensureHealthHistoryTaskCompleted gettasks failed', e)
      }
    },
    async submit2() {
      await this.$router.push({ path: '/' })
    },
    async processNextTask(task) {
      let taskRes
      this.setTaskCode(task.taskType)
      switch (task.taskType) {
        case 'NPH':
        case 'AANPH':
        case 'INS':
        case 'AACH':
          await this.clearUrlLinkInfo()
          if (task.info !== '') {
            var taskinfo = JSON.parse(task.info)
            taskinfo.TaskType = task.taskType
            taskinfo.TaskID = task.taskID
            this.setTaskInfo(JSON.stringify(taskinfo))
          } else {
            this.setTaskInfo('')
          }
          this.setTaskCurrentTaskType('PatientInfo')
          await this.$router.push({ path: '/task' })
          break
        case 'CH':
          await this.clearUrlLinkInfo()
          this.setTaskInfo(task.info)
          this.setTaskItem(task)
          this.setTaskCurrentTaskType('PatientInfo')
          await this.$router.push({ path: '/task' })
          break
        case 'MSG':
          taskRes = await api.task.request.getSpecificTask(task.taskID)
          await api.task.request.updateTaskComplete({
            facilityId: this.currentPatientAssociated.facilityID,
            id: task.taskID,
            patientId: this.currentPatientAssociated.patientID
          })
          await this.clearUrlLinkInfo()
          this.setCurrentMsgInfo({
            id: parseInt(taskRes.data.info),
            subject: ''
          })
          this.setMsgCurrentPage('Detail')
          this.$router.push({ path: '/menu/messages' })
          break
        case 'STMT':
          taskRes = await api.task.request.getSpecificTask(task.taskID)
          this.setBillingStatementTask(taskRes.data)
          await this.clearUrlLinkInfo()
          this.$router.push({ path: '/menu/statement' })
          break
        case 'FORM':
          await this.clearUrlLinkInfo()
          var info = JSON.parse(task.info)
          var routeData = this.$router.resolve({
            name: 'HandlerForm',
            query: {
              i: info.FacilityFormID,
              t: info.FormName,
              p: info.Data.PatientName,
              pid: task.patientID,
              tid: task.taskID
            }
          })
          var isMobileDevice = window.navigator.userAgent
            .toLowerCase()
            .includes('mobi')
          if (isMobileDevice) {
            window.location.href = routeData.href
          } else {
            // Desktop: stay in the same tab
            window.location.href = routeData.href
          }
          break
        default:
          await this.setTaskCurrentTaskType(task.taskType)
          await this.$router.push({ path: '/task' })
          break
      }
    },
    async checkAndProcessRemainingTasks() {
      try {
        // Current task we just completed — must be known so we never treat it as "remaining"
        const currentTaskIdRaw =
          this.TaskInfo?.TaskID ?? this.TaskInfo?.taskID ?? this.TaskItem?.taskID
        const currentTaskId =
          currentTaskIdRaw !== undefined && currentTaskIdRaw !== null
            ? Number(currentTaskIdRaw)
            : undefined

        // If we can't identify what we just completed, show thank you and do NOT load another task
        if (currentTaskId === undefined || Number.isNaN(currentTaskId)) {
          this.showThankYou = true
          return
        }

        const res = await api.patient.request.gettasks({
          facilityId: this.currentPatientAssociated.facilityID,
          patientId: this.currentPatientAssociated.patientID
        })
        const raw = res.data
        const taskList = Array.isArray(raw) ? raw : (raw?.tasks && Array.isArray(raw.tasks) ? raw.tasks : [])

        // Filter out tasks with taskID === 0 (completed) and the task we just completed
        const remainingTasks = taskList.filter((task) => {
          const id = Number(task.taskID)
          return id > 0 && id !== currentTaskId
        })

        // If the server still shows our task as incomplete, do NOT load another task — show thank you
        const serverStillHasOurTask = taskList.some(
          (task) => Number(task.taskID) === currentTaskId && Number(task.taskID) > 0
        )
        if (serverStillHasOurTask) {
          this.showThankYou = true
          return
        }

        if (remainingTasks.length > 0) {
          // Prefer processing remaining FORM tasks before other task types
          const nextTask =
            remainingTasks.find((task) => task.taskType === 'FORM') ||
            remainingTasks[0]
          await this.processNextTask(nextTask)
        } else {
          // No more tasks, show thank you message
          this.showThankYou = true
        }
      } catch (error) {
        console.error('Error checking remaining tasks:', error)
        // On error, show thank you message
        this.showThankYou = true
      }
    },
    prev() {
      const currentIndex = this.getTaskPreviousTaskType.findIndex(
        (c) => c === this.getTaskCurrentTaskType
      )
      let prevPage = ''
      if (currentIndex === -1) {
        prevPage =
          this.getTaskPreviousTaskType[this.getTaskPreviousTaskType.length - 1]
      } else {
        prevPage = this.getTaskPreviousTaskType[currentIndex - 1]
      }
      this.setTaskCurrentTaskType({
        back: true,
        page: prevPage,
        removePage: this.getTaskCurrentTaskType
      })
    }
  },
  async mounted() {
    this.isLoading = true
    // complete the task without having submit button clicked - requested here https://sprints.zoho.com/workspace/healthcoretech#P7/itemdetails/I155/details
    await this.submit()

    // Wait for server to persist completion before checking remaining tasks (avoids same task reappearing)
    await new Promise(resolve => setTimeout(resolve, 1000))
    await this.checkAndProcessRemainingTasks()

    // Only load case history questions and set loading to false if we're showing the thank you page
    // If we're redirecting to another task, the component will be unmounted
    if (this.showThankYou) {
      const caseHistoryQuestions = await api.task.request.getCaseHistoryQuestions(
        {
          facilityId: this.currentPatientAssociated.facilityID,
          caseHistoryId: this.getTaskCurrentCaseHistoryId
        }
      )

      const record = caseHistoryQuestions.data.filter(
        (c) =>
          c.description === 'SeenChiropractor' || c.description === 'DoctorToKnow'
      )
      // console.log('record', record)
      record.forEach((c) => {
        const update = this.form.questions.find((x) => x.code === c.description)
        // console.log('update', update)
        if (update) {
          update.answer = c.answer
        }
      })

      this.isLoading = false
    }
  }
}
</script>

<style></style>
